import React from 'react';

import { NODE_TYPE as NT } from 'shared/constants/slate';

import { BulletedList, NumberedList, ListItem } from './list';
import { CodeBlock, CodeLine } from './codeBlock';
import { HeadlineSwitch } from './headline';
import { Blockquote } from './blockquote';
import { Paragraph } from './paragraph';
import { Heading } from './heading';
import { Image } from './image';
import { Embed } from './embed';
// import { Link } from './link';


const renderDefaultNode = (props) => {
  switch (props.node.type) {
    case NT.headline: return <HeadlineSwitch {...props} />;
    case NT.blockquote: return <Blockquote {...props} />;
    case NT.codeBlock: return <CodeBlock {...props} />;
    case NT.codeLine: return <CodeLine {...props} />;
    case NT.paragraph: return <Paragraph {...props} />;
    case NT.heading: return <Heading {...props} />;
    case NT.image: return <Image {...props} />;
    case NT.embed: return <Embed {...props} />;
    case NT.ul: return <BulletedList {...props} />;
    case NT.ol: return <NumberedList {...props} />;
    case NT.li: return <ListItem {...props} />;
    default: return <Paragraph {...props} />;
  }
};


export {
  // XXX: Do we really need to export all these?
  HeadlineSwitch,
  CodeBlock,
  CodeLine,
  Blockquote,
  BulletedList,
  NumberedList,
  ListItem,
  Heading,

  // inlineNodes,
  renderDefaultNode,
};



// WEBPACK FOOTER //
// ./src/components/slate/nodes/index.js